import React from 'react';
import WOW from 'wowjs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import translate from '../translate';

function Workflow() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'workflow';

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init(); 
    }, []);
    
    function activateBox(e) {
        const boxes = document.querySelectorAll('.workflow-box');
        boxes.forEach(box => box.classList.remove('active'));
        e.currentTarget.classList.add('active');
    }
    return (
        <div className="workflow-section theme-light-bg pb-130 pt-125">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="section-heading text-center mb-60">
                        <span className="sub-heading">{translate(componentName, 'subHeading', language)}</span>
                        <h2 className="heading">{translate(componentName, 'heading', language)}</h2>
                    </div>
                </div>
            </div>
            <div className="row g-0 mt-none-40">
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 mt-40">
                    <div className="workflow-box workflow-box__1 text-center wow fadeInUp" data-wow-delay="0ms" data-wow-duration="800ms" onMouseEnter={(e) => activateBox(e)}>
                        <div className="icon">
                            <img src="assets/img/icons/workflow-icon-1.png" alt=""/>
                            <span className="count">01</span>
                        </div>
                        <div className="content">
                            <h5 className="title">{translate(componentName, 'step1Title', language)}</h5>
                            <p>{translate(componentName, 'step1Description', language)}</p>
                        </div>
                        <div className="dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 mt-40 wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms">
                    <div className="workflow-box workflow-box__2 active text-center" onMouseEnter={(e) => activateBox(e)}>
                        <div className="icon">
                            <img src="assets/img/icons/workflow-icon-2.png" alt=""/>
                            <span className="count">02</span>
                        </div>
                        <div className="content">
                            <h5 className="title">{translate(componentName, 'step2Title', language)}</h5>
                            <p>{translate(componentName, 'step2Description', language)}</p>
                        </div>
                        <div className="dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 mt-40 wow fadeInUp" data-wow-delay="400ms" data-wow-duration="800ms">
                    <div className="workflow-box workflow-box__3 text-center" onMouseEnter={(e) => activateBox(e)}>
                        <div className="icon">
                            <img src="assets/img/icons/workflow-icon-3.png" alt=""/>
                            <span className="count">03</span>
                        </div>
                        <div className="content">
                            <h5 className="title">{translate(componentName, 'step3Title', language)}</h5>
                            <p>{translate(componentName, 'step3Description', language)}</p>
                        </div>
                        <div className="dots">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 mt-40">
                    <div className="workflow-box workflow-box__4 text-center wow fadeInUp" data-wow-delay="600ms" data-wow-duration="800ms" onMouseEnter={(e) => activateBox(e)}>
                        <div className="icon">
                            <img src="assets/img/icons/workflow-icon-4.png" alt=""/>
                            <span className="count">04</span>
                        </div>
                        <div className="content">
                            <h5 className="title">{translate(componentName, 'step4Title', language)}</h5>
                            <p>{translate(componentName, 'step4Description', language)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Workflow;